"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../../../basics/Icon"));
var typography_1 = require("../../../../typography");
var TextButton_1 = __importDefault(require("../../../../misc/TextButton"));
var Markdown_1 = __importDefault(require("../../../../utils/Markdown"));
var styles_1 = require("./styles");
var MARKDOWN_1_OVERRIDES = {
    p: function (_a) {
        var children = _a.children;
        return (react_1.default.createElement(typography_1.Body, { level: "3", color: "WHITE" }, children));
    },
    a: function (_a) {
        var children = _a.children, href = _a.href;
        var external = !href.startsWith('/');
        return (react_1.default.createElement(styles_1.Link, { href: href, isExternal: external }, children));
    },
};
var Banner = function (_a) {
    var onClose = _a.onClose, children = _a.children;
    return (react_1.default.createElement(styles_1.Wrapper, null,
        react_1.default.createElement(styles_1.Inner, null,
            react_1.default.createElement(styles_1.Text, null,
                react_1.default.createElement(Icon_1.default, { name: "shape-diamond", color: "YELLOW_50" }),
                react_1.default.createElement(Markdown_1.default, { overrides: MARKDOWN_1_OVERRIDES }, children)),
            react_1.default.createElement(TextButton_1.default, { "aria-label": "Dismiss", onClick: function (e) {
                    e.persist();
                    e.preventDefault();
                    e.stopPropagation();
                    onClose && onClose();
                }, color: "WHITE", hoverColor: "GREY_20" },
                react_1.default.createElement(Icon_1.default, { name: "close" })))));
};
exports.default = Banner;
